module.exports = __webpack_public_path__ + "data/customers.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/customers/customers.json
// module id = 8RgO
// module chunks = 1